export default "__VITE_PUBLIC_ASSET__d76ffa42__"